export const ANALYTICS = {
  CATEGORY: {
    APP: "APP",
    USER: "USER",
    PORTFOLIO: "PORTFOLIO",
    CUSTODIAN: "CUSTODIAN",
    BENEFICIARY: "BENEFICIARY",
    SAFE_DEPOSIT_BOX: "SAFE_DEPOSIT_BOX",
    LOG_ROCKET: "LogRocket",
    ALL: "All"
  },
  ACTION: {
    ADD: "ADD",
    EDIT: "EDIT",
    EDIT_TRUSTED_ANGEL: "EDIT_TRUSTED_ANGEL",
    EDIT_PHONE: "EDIT_PHONE",
    BILLBOARD: "BILLBOARD_OPENED",
    NETWORTH_VANITY: "NETWORTH_VANITY_OPENED",
    VANITY_CLUB: "VANITY_CLUB_OPENED",
    VANITY_CLUB_BLANK: "VANITY_CLUB_BLANK_STATE",
    REMOVE: "REMOVE",
    EXPORT: "EXPORT",
    SHEET_ADD: "SHEET_ADD",
    SIGNED_UP: "Signed Up",
    START_TRIAL: "Start Trial",
    EMAIL_SUBMITTED: "Email Submitted",
    SUBSCRIBED: "Subscribed",
    SUBSCRIBED_REPEAT: "Subscribed Repeat",
    APP_LOADED: "K_APP_LOADED",
    PAGE_LOADED: "K_PAGE_LOADED",
    "1D_OPEN": "1D_OPEN",
    SEARCH_PORTFOLIO: "SEARCH_PORTFOLIO",
    CURRENCY_CHANGE: "CURRENCY_CHANGE",
    CASH_ON_HAND: "CASH_ON_HAND",
    RECAP_OPENED: "RECAP_OPENED",
    CANCEL_INITIATED: "CANCEL_INITIATED",
    CANCEL_ABORTED: "CANCEL_ABORTED",
    CANCEL_COMPLETED: "CANCEL_COMPLETED",
    FF_PROJECTIONS_OPENED: "FF_PROJECTIONS_OPENED",
    FF_CHARTS_OPENED: "FF_CHARTS_OPENED",
    FF_CASHFORECAST_OPENED: "FF_CASHFORECAST_OPENED",
    VANITY_CLUB_HOME_CLICK: "VANITY_CLUB_OPENED_FROM_HOME",
    VANITY_CLUB_CASH_CLICK: "VANITY_CLUB_OPENED_FROM_CASH",
    VANITY_CLUB_INVESTABLE_CLICK: "VANITY_CLUB_OPENED_FROM_INVESTABLE",
    VANITY_CLUB_CAGR_CLICK: "VANITY_CLUB_OPENED_FROM_CAGR",
    VANITY_CLUB_PERCENTILE_CLICK: "VANITY_CLUB_OPENED_FROM_PERCENTILE",
    VERIFIED_CONNECTED: "VERIFIED_CONNECTED"
  }
};
